import { DisclaimerContentPageStory } from "../../lib/storyblok/types/stories/DisclaimerContentPageStory";
import { StoryblokStoryComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { ViewModel } from "../../lib/viewModel/createViewModel";
import AnchorMenu from "../Layout/AnchorMenu/AnchorMenu";
import { AnchorMenuContextProvider } from "../Layout/AnchorMenu/AnchorMenuContext";
import AnchorMenuSection from "../Layout/AnchorMenu/AnchorMenuSection";
import { splitIntoSections } from "../Layout/AnchorMenu/splitIntoSections";
import DisclaimerBlock from "../../ui/DisclaimerBlock";
import { useState } from "react";
import HeroSection from "../Nestable/HeroSection";

type VM = ViewModel<DisclaimerContentPageStory>;

const DisclaimerContentPage: StoryblokStoryComponent<VM> = ({ story }) => {
  const {
    hero,
    body,
    activateDisclaimer,
    anchorMenuButton,
    hideStickyMenu,
    disclaimerTitle,
    disclaimerDescription,
    disclaimerOptionsList,
    disclaimerAuthorizedOptions,
    disclaimerSecondPageButtonText,
    disclaimerSecondPageSecondaryButtonText,
    disclaimerMainButtonText,
    disclaimerSecondaryButtonLink,
    disclaimerSecondaryButtonText,
    disclaimerRestrictedAccessTitle,
    disclaimerAuthorizedContentDescription,
    disclaimerRestrictedAccessContentDescription,
    disclaimerAuthorizedContentTitle,
    disclaimerHasSecondPage,
    disclaimerFirstDropDownTitle,
  } = story.content;

  const sections = splitIntoSections(body);
  const [showDisclaimerContent, setShowDisclaimerContent] = useState(false);
  return (
    <>
      {activateDisclaimer && !showDisclaimerContent && (
        <DisclaimerBlock
          disclaimerTitle={disclaimerTitle}
          disclaimerDescription={disclaimerDescription}
          disclaimerOptionsList={disclaimerOptionsList}
          disclaimerAuthorizedOptions={disclaimerAuthorizedOptions}
          disclaimerAuthorizedContentDescription={
            disclaimerAuthorizedContentDescription
          }
          disclaimerAuthorizedContentTitle={disclaimerAuthorizedContentTitle}
          disclaimerRestrictedAccessTitle={disclaimerRestrictedAccessTitle}
          disclaimerRestrictedAccessContentDescription={
            disclaimerRestrictedAccessContentDescription
          }
          setShowContent={setShowDisclaimerContent}
          disclaimerSecondaryButtonLink={disclaimerSecondaryButtonLink}
          disclaimerSecondaryButtonText={disclaimerSecondaryButtonText}
          disclaimerMainButtonText={disclaimerMainButtonText}
          disclaimerFirstDropDownTitle={disclaimerFirstDropDownTitle}
          disclaimerSecondPageSecondaryButtonText={
            disclaimerSecondPageSecondaryButtonText
          }
          disclaimerSecondPageButtonText={disclaimerSecondPageButtonText}
          disclaimerHasSecondPage={disclaimerHasSecondPage}
        />
      )}
      {(showDisclaimerContent || !activateDisclaimer) && (
        <AnchorMenuContextProvider>
          <HeroSection blocks={hero} />

          {sections.length > 1 && !hideStickyMenu && (
            <AnchorMenu sections={sections} button={anchorMenuButton?.[0]} />
          )}

          {sections?.map((section) => (
            <AnchorMenuSection
              key={`${section.href ? section.href : "index"}-${story.uuid}`}
              section={section}
            />
          ))}
        </AnchorMenuContextProvider>
      )}
    </>
  );
};

export default DisclaimerContentPage;
